<p-dialog header="User Profile" [(visible)]="cmpVisible"
          (onHide)="hide()"
          [modal]="true" [style]="{ minWidth: '800px' }" [maximizable]="false" [baseZIndex]="10000">
  <form [formGroup]="form" (submit)="save(form.getRawValue())">

    <div class="row form-group">
      <div class="col-4"><span class="field-required">*&nbsp;</span>Mission Code</div>
      <div class="col-8">
        <input pInputText formControlName="missionCode" class="form-control" type="text" placeholder="Required"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-show-error [control]="form.get('missionCode')"></app-show-error>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-4"><span class="field-required">*&nbsp;</span>Country/Administrative Area</div>
      <div class="col-8">
        <p-dropdown [options]="countries"
                    [filter]="true"
                    styleClass="w-100"
                    placeholder="Required"
                    formControlName="country"
                    appendTo="body"></p-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-show-error [control]="form.get('country')"></app-show-error>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-4"><span class="field-required">*&nbsp;</span>City</div>
      <div class="col-8">
        <input pInputText formControlName="city" class="form-control" type="text" placeholder="Required"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-show-error [control]="form.get('city')"></app-show-error>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-4"><span class="field-required">*&nbsp;</span>Institution type</div>
      <div class="col-8">
        <div class="row">
          <div class="col-4">
            <div class="form-check">
              <p-radioButton inputId="institutionType1" name="institutionType" value="Institutions"
                             formControlName="institutionType"></p-radioButton>
              <label class="form-check-label" for="institutionType1">Institutions</label>
            </div>
          </div>
          <div class="col-3">
            <div class="form-check">
              <p-radioButton inputId="institutionType2" name="institutionType" value="Societies"
                             formControlName="institutionType"></p-radioButton>
              <label class="form-check-label" for="institutionType2">Societies</label>
            </div>
          </div>
          <div class="col-5">
            <div class="form-check">
              <p-radioButton inputId="institutionType3" name="institutionType" value="ResearchAssistant"
                             formControlName="institutionType"></p-radioButton>
              <label class="form-check-label" for="institutionType3">Research Assistant</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-show-error [control]="form.get('institutionType')"></app-show-error>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-4"><span class="field-required">*&nbsp;</span>Institution name</div>
      <div class="col-8">
        <p-dropdown [options]="institutionNames"
                    [filter]="true"
                    styleClass="w-100"
                    placeholder="Required"
                    formControlName="institutionName"
                    appendTo="body"></p-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-show-error [control]="form.get('institutionName')"></app-show-error>
      </div>
    </div>

    <div class="p-fluid">
      <div class="row form-group">
        <div class="col-4"><span class="field-required">*&nbsp;</span>First name</div>
        <div class="col-8">
          <input pInputText formControlName="firstName" class="form-control" type="text" placeholder="Required"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-show-error [control]="form.get('firstName')"></app-show-error>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-4"><span class="field-required">*&nbsp;</span>Last name</div>
        <div class="col-8">
          <input pInputText formControlName="lastName" class="form-control" type="text" placeholder="Required"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-show-error [control]="form.get('lastName')"></app-show-error>
        </div>
      </div>
      <div class="row form-group" *ngIf="form.get('isAdmin').value === 4">
        <div class="col-4"><span class="field-required">*&nbsp;</span>Password</div>
        <div class="col-8">
          <p-password formControlName="psw" inputStyleClass="form-control"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-show-error [control]="form.get('psw')"></app-show-error>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-4">Phone</div>
        <div class="col-8">
          <input pInputText formControlName="phone" type="text"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-show-error [control]="form.get('phone')"></app-show-error>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-4"><span class="field-required">*&nbsp;</span>Email</div>
        <div class="col-8">
          <input pInputText formControlName="email" class="form-control" type="text"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-show-error [control]="form.get('email')"></app-show-error>
        </div>
      </div>
      <div class="row form-group" *ngIf="userIdVisible">
        <div class="col-4">UserID</div>
        <div class="col-8">
          <div class="input-group">
            <input pInputText formControlName="id" class="form-control-local" type="text"/>
            <button pButton type="button" icon="pi pi-clone" style="font-size: 0.8em"
                    ngxClipboard [cbContent]="form.get('id').value" cbSuccessMsg="UserID is copied to clipboard"
            ></button>
          </div>
        </div>
      </div>
      <div class="row form-group" *ngIf="userIdVisible">
        <div class="col-4">KeycloakID</div>
        <div class="col-8">
          <div class="input-group">
            <input pInputText formControlName="keycloakId" class="form-control-local" type="text"/>
            <button pButton type="button" icon="pi pi-clone" style="font-size: 0.8em"
                    [disabled]="!form.get('keycloakId').value"
                    ngxClipboard [cbContent]="form.get('keycloakId').value"
                    cbSuccessMsg="KeycloakID is copied to clipboard"
            ></button>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <div class="form-check">
              <p-checkbox inputId="enabled" name="access" formControlName="enabled" binary="true"></p-checkbox>
              <label class="form-check-label" for="enabled">Enabled</label>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <div class="form-check">
              <p-checkbox inputId="sendActivationEmail" name="sendActivationEmail"
                          formControlName="sendActivationEmail" binary="true"></p-checkbox>
              <label class="form-check-label" for="sendActivationEmail">Send an activation email</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-check">
            <p-radioButton inputId="isAdmin0" name="isAdmin" [value]="0" formControlName="isAdmin"></p-radioButton>
            <label class="form-check-label" for="isAdmin0">None</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-check">
            <p-radioButton inputId="isAdmin1" name="isAdmin" [value]="1" formControlName="isAdmin"></p-radioButton>
            <label class="form-check-label" for="isAdmin1">System Administrator</label>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <div class="form-check">
            <p-radioButton inputId="isAdmin4" name="isAdmin" [value]="4" formControlName="isAdmin"></p-radioButton>
            <label class="form-check-label" for="isAdmin4">API User</label>
          </div>
        </div>
      </div>
      <div class="row form-group" *ngIf="form.get('isAdmin').value === 4">
        <div class="col-4"><span class="field-required">*&nbsp;</span>API token lifetime (in days)</div>
        <div class="col-8">
          <input pInputText formControlName="accessTokenValidity" class="form-control"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-show-error [control]="form.get('accessTokenValidity')"></app-show-error>
        </div>
      </div>
      <div class="row" *ngIf="form.get('id').value">
        <div class="col-12">
          <button type="button" class="btn btn-link" (click)="showUserProjects()">Assigned questionnaires</button>
        </div>
      </div>
    </div>

    <div class="row float-right">
      <div class="col-12">
        <button pButton type="submit" icon="pi pi-save" label="Save"
                [disabled]="saveButtonDisabled"></button>
        <button pButton type="button" icon="pi pi-times"
                [disabled]="cancelButtonDisabled"
                (click)="hide()" label="Close"></button>
      </div>
    </div>
  </form>
</p-dialog>
